import { message } from 'antd';

import { POST } from 'src/network/apiHandler';
import config from 'src/globals';
import { GET_ASSIGNED_DRIVERS } from 'src/api/routes';
import {
  SET_ASSIGNED_DRIVERS,
  SET_ASSIGNED_DRIVERS_LOADER,
} from 'src/common/actions/constants';

const { API_BASE_URL } = config;

export const getAssignedDrivers = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_ASSIGNED_DRIVERS_LOADER,
    data: true,
  });
  const response = await POST(API_BASE_URL + GET_ASSIGNED_DRIVERS, data);
  if (response.isSuccess) {
    dispatch({
      type: SET_ASSIGNED_DRIVERS,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_ASSIGNED_DRIVERS_LOADER,
    data: false,
  });
};
